import type { ApiClient } from '../api'

export const getUserNotifications = async (api: ApiClient, agencyId: number) => {
	const { data } = await api.get<UserNotificationsResponse>(`/api/agencies/${agencyId}/user_notifications`)

	return data
}

export interface UserNotification {
	description: string
	timestamp: string
}

export interface UserNotificationCollection {
	shared_completions?: UserNotification[]
}

export interface UserNotificationsResponse {
	notifications: UserNotificationCollection
}
